export default __webpack_public_path__ + "static/media/mismatch-return.a272a499.png";